// extracted by mini-css-extract-plugin
module.exports = {"inputBox":"styles_inputBox__1clnY","inputRow":"styles_inputRow__1v6TN","submit":"styles_submit__LBDaJ","accepted":"styles_accepted__29ds-","spin":"styles_spin__10pGO"};